// src/api/index.js
import axios from 'axios';
import {error, warning} from "@/utils/elMessage";
import {loading} from "@/components/loading/loading";
import router from "@/router";
import store from "@/store";
import {ElMessageBox} from "element-plus";
import {isContains} from "@/utils/fun";


const interceptorsPath = {
    prefix: ['admin'],
    url: ['/update-user-info', '/comment/add']
}


let refreshTokenPromise = null
/**
 * 刷新Token并重试请求的函数
 * @param originalRequest
 * @param fun
 */
const refreshTokenAndRetry = async (originalRequest, fun) => {
    if (!refreshTokenPromise) { // 如果没有正在进行的刷新Token操作，则开始一个新的
        refreshTokenPromise = store.dispatch('user/REFRESH_TOKEN')
            .then(_ => {
                // 成功刷新后清除promise以便下次使用
                refreshTokenPromise = null;
            })
            .catch(err => {
                // 刷新失败时也清除promise以便下次尝试
                refreshTokenPromise = null;
                return Promise.reject(new Error('请先登录~'))
            });
    }

    try {
        await refreshTokenPromise

        return fun(originalRequest)
    } catch (e) {
        error({msg: '请先登录~', duration: 5 * 1000})
        // router.push({ path: '/login'}).then(_=>{})

        ElMessageBox.confirm('是否进行登录？', {confirmButtonText: '确认', cancelButtonText: '取消'})
            .then(_ => {
                store.dispatch('user/LOGIN_OUT').then(_ => {
                }).catch(_ => {
                })
                router.push({path: '/login'}).then(_ => {
                }).catch(_ => {
                })
            })
            .catch(_ => {
            })
        return Promise.reject(new Error('请先登录~'))
    }
}

/**
 * axios创建
 * @param prefix 前缀
 */
const createApiClient = (prefix) => {
    const apiClient = axios.create({
        baseURL: `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_API_PREFIX}/${prefix}/`,
        // 过期时间
        timeout: 60000,
    });
    // 请求拦截
    apiClient.interceptors.request.use(config => {
        loading.show()
        config.headers['auth'] = 'auth'
        if (store.getters["user/isLogin"]) {
            config.headers['Authorization'] = 'Bearer ' + store.getters["user/token"]
            // config.headers['refreshAuthorization'] = 'Bearer ' + store.getters["user/refreshToken"]
        }
        if (config.url === '/refresh-token') {
            config.headers['refreshAuthorization'] = 'Bearer ' + store.getters["user/refreshToken"]
        }
        if (isContains(interceptorsPath.prefix, prefix) || isContains(interceptorsPath.url, config.url)) {
            if (!store.getters["user/isLogin"]) {
                return Promise.reject({
                    status: 4001,
                    msg: '请先登录后使用~'
                });
            }
        }

        return config
    }, err => {
        loading.hide()
        error({msg: err.msg || '系统异常', duration: 5 * 1000})
        return Promise.reject(err)
    })

    // 响应拦截
    apiClient.interceptors.response.use(response => {
        loading.hide()
        if (response.status !== 200) {
            error({msg: '系统异常', duration: 5 * 1000})
            return Promise.reject('系统异常')
        }
        if (response.request.responseType === 'blob') {
            return response
        }
        const {code, success} = response.data
        if (success) {
            return response.data.data
        }
        if (code === 401) {
            return refreshTokenAndRetry(response.config, apiClient)
        }
        if (code === 403) {
            error({msg: response.data.msg || '权限不足', duration: 5 * 1000})
            return Promise.reject(new Error(response.data.msg || '权限不足'))
        }
        if (code === 500) {
            error({msg: response.data.msg || '系统异常', duration: 5 * 1000})
            return Promise.reject(new Error(response.data.msg || '系统异常'))
        }
    }, err => {
        loading.hide()
        if (err.status === 404) {
            error({msg: '请求404', duration: 5 * 1000})
            return Promise.reject(err)
        }
        if (err.status === 403) {
            error({msg: '拒绝访问403', duration: 5 * 1000})
            return Promise.reject(err)
        }
        if (err.status === 4001) {
            warning({msg: err.msg || '请先登录后使用~', duration: 5 * 1000})
            return Promise.reject(err)
        }
        error({msg: err.msg || '系统异常', duration: 5 * 1000})
        return Promise.reject(err)
    })

    return apiClient
}

/**
 * 后台
 */
const adminRequest = createApiClient('admin')
/**
 * 前端
 */
const uiRequest = createApiClient('ui')
/**
 * 认证
 */
const authRequest = createApiClient('auth')

export {
    adminRequest,
    uiRequest,
    authRequest
}
